import React, { useState, useEffect, useRef } from 'react';
 

const PORTFOLIO_DATA = [
  { id: 0, title: 'Kimono', category: 'Indoor', imgUrl: '/arts/khultstudio-arts.jpg' },
  { id: 1, title: 'Elisa & Family', category: 'Indoor',imgUrl: '/arts/khultstudio-arts1.jpg' },
  { id: 2, title: 'Zoyenna', category: 'Indoor', imgUrl: '/arts/khultstudio-arts2.jpg' },
  { id: 3, title: 'Baby Sunshine', category: 'Indoor', imgUrl: '/arts/khultstudio-arts3.jpg' },
  { id: 4, title: 'Little Dreamer', category: 'Indoor', imgUrl: '/arts/khultstudio-arts4.jpg' }
];

const Sliders = () => {
  const [items, setItems] = useState(PORTFOLIO_DATA);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const autoPlayRef = useRef(null);

  // Accelerated loop cycle logic
  const handleNext = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);

    setTimeout(() => {
      setItems((prevItems) => {
        const [first, ...rest] = prevItems;
        return [...rest, first];
      });
      setIsTransitioning(false);
    }, 350); // Matches the fast CSS transition time
  };

  const handlePrev = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);

    setItems((prevItems) => {
      const last = prevItems[prevItems.length - 1];
      const rest = prevItems.slice(0, prevItems.length - 1);
      return [last, ...rest];
    });

    setTimeout(() => {
      setIsTransitioning(false);
    }, 350);
  };

  useEffect(() => {
    autoPlayRef.current = setInterval(() => {
      handleNext();
    }, 3000); // Quick turnaround hold delay between transitions

    return () => {
      if (autoPlayRef.current) clearInterval(autoPlayRef.current);
    };
  }, [items, isTransitioning]);

  const activeStageView = items.slice(0, 4);

  return (
    <div className="container-fluid portfolio-container" style={{ backgroundImage: 'url(/arts/khultstudio-arts-bgc.jpg)' }}>
      {/* Rapid backdrop image updates */}
      <div 
        className="portfolio-ambient-bg" 
        style={{ backgroundImage: `url(${activeStageView[0]?.imgUrl})` }} 
      />

      <div className="portfolio-wrapper">
        <div className="side-tag-container">
          <span className="vertical-side-tag" style={{ fontSize:'60px' }}>Our Arts</span>
        </div>

        <div className="slider-viewport">
          <div 
            className={`slider-track ${isTransitioning ? 'is-moving' : ''}`}
            style={{
              transform: isTransitioning ? 'translateX(-480px)' : 'translateX(0px)'
            }}
          >
            {activeStageView.map((item, index) => {
              const isSlotOne = index === 0;
              const isSlotTwo = index === 1;
              const isSlotThree = index === 2;

              return (
                <div 
                  key={item.id} 
                  className={`portfolio-card-wrapper ${!isSlotOne ? 'inactive-slide' : ''}`}
                  onClick={() => { if (!isSlotOne) handleNext(); }}
                >
                  <div className={`portfolio-card-frame ${isSlotOne ? 'tall-frame' : 'short-frame'}`}>
                    <img src={item.imgUrl} alt={item.title} className="slider-img" />
                    <div className="cinematic-overlay" />

                    {isSlotOne && (
                      <>
                        <button className="inline-nav-arrow arrow-left-pos" onClick={(e) => { e.stopPropagation(); handleNext(); }}>
                          &#8594;
                        </button>
                        <div className="position-absolute bottom-0 start-0 p-4 pb-5 text-white">
                          <h1 className="m-0 display-3 fixed-vertical-title">
                            {item.title}
                          </h1>
                        </div>
                      </>
                    )}

                    {isSlotThree && (
                      <button className="inline-nav-arrow arrow-right-pos" onClick={(e) => { e.stopPropagation(); handlePrev(); }}>
                        &#8592;
                      </button>
                    )}
                  </div>

                  {!isSlotOne && (
                    <div className="meta-underlay text-start" style={{ opacity: isSlotTwo || isSlotThree ? 1 : 0 }}>
                      <div className="meta-category">{item.category}</div>
                      <h3 className="meta-title">{item.title}</h3>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Sliders;